import { useAppSelector } from "@/Store/Store"
import { Auth } from "@/constants/auth"
import { useMemo } from "react"


const useGetAuth = () => {
	const auth = useAppSelector(state => state.user.profile.auth)
	const auths = useMemo(() => {
		return {
			isAuthAdd: auth.includes(Auth.ADD),
			isAuthDelete: auth.includes(Auth.DELETE),
			isAuthAddAccount: auth.includes(Auth.ADD_ACCOUNT)
		}
	}, [auth])

  return auths
}

export default useGetAuth